const locale = {
  TotalText: 'Total',
  ItemText: 'items',
  UnnamedColumn: 'Unnamed',
  EditTable: 'Edit Table',
  RestoreDefault: 'Restore Default',
  VisibleInfo: 'Visible Columns',
  HiddenInfo: 'Hidden Columns',
  Search: 'Search',
  BatchOperations: 'Batch Actions',
  BatchOperationsWithCount: 'Batch Actions (Selected: {count})',
  BatchOperationsMobileSelected: 'Selected: {count}',
  Cancel: 'Cancel',
  Confirm: 'Confirm',
  All: 'All',
  SwitchToCardView: 'Switch to card view',
  SwitchToTableView: 'Switch to table view'
};

export default locale;
